// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PortalLogo_wrapper__a796_","resizable":"PortalLogo_resizable__7STXn","mobile":"PortalLogo_mobile__qpzwn"};